import request from '@/utils/bsyq-request';

// 分页查询直播回放
export function getLivePlaybacks(params) {
  return request({
    url: '/api/services/app/Live/GetLivePlaybacks',
    method: 'get',
    params,
  });
}

// 分页查询直播列表
export function getLiveRooms(params) {
  return request({
    url: '/api/services/app/Live/GetLiveRooms',
    method: 'get',
    params,
  });
}
